import React from "react";
import { useClasses } from "../../";
import classNames from "classnames";
import { styles as radiosStyles } from "./Radio";
const style = (theme) => {
    const radioClasses = radiosStyles(theme);
    return {
        radioLabel: radioClasses.radioLabel,
        radio: radioClasses.radio,
        radioIcon: radioClasses.radioIcon,
        radioPosition: radioClasses.radioPosition,
        radioIconSelected: radioClasses.radioIconSelected,
        helpBlock: radioClasses.helpBlock,
        hasError: radioClasses.hasError,
        checkboxIndicator: {
            border: `3px solid ${theme.palette.get("formBackground")}`,
            boxSizing: "border-box",
        },
        checkboxIndicatorError: {
            border: `3px solid ${theme.palette.get("danger")}`,
            boxSizing: "border-box",
        },
        checkboxIndicatorSelected: {
            border: `3px solid ${theme.palette.get("primary")}`,
            backgroundColor: `${theme.palette.get("primary")}`,
            "&:after": {
                content: '""',
                border: "solid #fff",
                borderWidth: "0 3px 3px 0",
                transform: "rotate(45deg)",
                width: "7px",
                height: "12px",
                position: "absolute",
                marginLeft: "2px",
                marginTop: "-2px",
            },
        },
        checkboxIndicatorSelectedError: {
            border: `3px solid ${theme.palette.get("danger")}`,
            backgroundColor: `${theme.palette.get("danger")}`,
        },
        inlineRadio: {
            margin: "0px 0px 0px 0px",
        },
        floating: {
            padding: "18px 0px 0px 0px",
        },
    };
};
const Checkbox = (props) => {
    const { override = {}, value, label, onChange = () => { }, error, info, inline, } = props;
    const classes = useClasses(style);
    const hasInfo = Boolean(info);
    const hasError = Boolean(error);
    return (React.createElement("div", { className: classNames([!inline && classes.floating]) },
        React.createElement("label", { className: classNames([classes.radioLabel, override && override.label]) },
            Boolean(label) && label,
            Boolean(props.children) && props.children,
            React.createElement("input", { className: classNames([
                    classes.radio,
                    classes.radioPosition,
                    hasError && classes.inputError,
                    override === null || override === void 0 ? void 0 : override.input,
                ]), type: "checkbox", checked: value, onChange: (e) => onChange(e.target.checked || false) }),
            React.createElement("span", { className: classNames([
                    classes.checkboxIndicator,
                    hasError && classes.checkboxIndicatorError,
                    classes.radioPosition,
                    value && classes.checkboxIndicatorSelected,
                    hasError && value && classes.checkboxIndicatorSelectedError,
                    override === null || override === void 0 ? void 0 : override.indicator,
                ]) },
                React.createElement("span", null))),
        hasInfo && !hasError && (React.createElement("span", { className: classNames([classes.helpBlock]) }, info)),
        hasError && (React.createElement("span", { className: classNames([classes.helpBlock, classes.hasError]) }, error))));
};
export default Checkbox;
